import {
  GET_PROFILE_DETAILS_INIT,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_PROFILE_DETAILS_FAILED,
  GET_ALLOCATOR_Strategy_INIT,
  GET_ALLOCATOR_Strategy_SUCCESS,
  GET_ALLOCATOR_Strategy_FAILED,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  GET_ALL_INVESTOR_SUCCESS,
  GET_ALL_INVESTOR_FAILED,
  GET_ALL_INVESTOR_INIT,
  GET_COMPANY_POST_FEED_INIT,
  GET_COMPANY_POST_FEED_SUCCESS,
  GET_COMPANY_POST_FEED_FAILED,
  GET_COMPANY_USERS_INIT,
  GET_COMPANY_USERS_SUCCESS,
  GET_COMPANY_USERS_FAILED,
  CREATE_ALLOCATOR_NETWORKS_INIT,
  CREATE_ALLOCATOR_NETWORKS_SUCCESS,
  CREATE_ALLOCATOR_NETWORKS_FAILED,
  UPDATE_ALLOCATOR_NETWORKS_INIT,
  UPDATE_ALLOCATOR_NETWORKS_SUCCESS,
  UPDATE_ALLOCATOR_NETWORKS_FAILED,
  DELETE_ALLOCATOR_NETWORKS_INIT,
  DELETE_ALLOCATOR_NETWORKS_SUCCESS,
  DELETE_ALLOCATOR_NETWORKS_FAILED,
} from "./constants";
const initialState = {
  loading: false,
  profileDetails: {},
  allocatorStratgy: [],
  stratgyList: [],
  updateAllocatorStratgy: [],
  getAllInvestors: [],
  updateTenantDetail: [],
  coverImageUrl: "",
  companyLogoUrl: "",
  getCompanyPostFeed: [],
  getCompanyUsers: [],
  page: 1,
  perPage: 5,
};

export default function allocatorProfile(state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE_DETAILS_INIT:
      return { ...state, loading: true };
    case GET_PROFILE_DETAILS_SUCCESS:
      return { ...state, loading: false, profileDetails: action.payload };
    case GET_PROFILE_DETAILS_FAILED:
      return { ...state, loading: false };
    case GET_ALLOCATOR_Strategy_INIT:
      return { ...state, loading: true };
    case GET_ALLOCATOR_Strategy_SUCCESS:
      return { ...state, loading: false, allocatorStratgy: action.payload };
    case GET_ALLOCATOR_Strategy_FAILED:
      return { ...state, loading: false };
    case GET_STRATEGY_INIT:
      return { ...state, loading: true };
    case GET_STRATEGY_SUCCESS:
      return { ...state, loading: false, stratgyList: action.payload };
    case GET_STRATEGY_FAILED:
      return { ...state, loading: false };
    case GET_ALL_INVESTOR_INIT:
      return { ...state, loading: true, };
    case GET_ALL_INVESTOR_SUCCESS:
      return { ...state, loading: false, getAllInvestors: action.payload };
    case GET_ALL_INVESTOR_FAILED:
      return { ...state, loading: false };
    case GET_COMPANY_POST_FEED_INIT:
      return { ...state, loading: true, };
    case GET_COMPANY_POST_FEED_SUCCESS:
      return { ...state, loading: false, getCompanyPostFeed: action.payload };
    case GET_COMPANY_POST_FEED_FAILED:
      return { ...state, loading: false };

    case GET_COMPANY_USERS_INIT:
      return { ...state, loading: true, };
    case GET_COMPANY_USERS_SUCCESS:
      return { ...state, loading: false, getCompanyUsers: action.payload };
    case GET_COMPANY_USERS_FAILED:
      return { ...state, loading: false };

    case CREATE_ALLOCATOR_NETWORKS_INIT:
      return { ...state, loading: true };
    case CREATE_ALLOCATOR_NETWORKS_SUCCESS:
      const result = state.profileDetails;
      result.recieverNetwork = action.payload;
      return {
        ...state,
        allocatorNetworks: result,
        loading: false,
      };
    case CREATE_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, loading: false };

    case UPDATE_ALLOCATOR_NETWORKS_INIT:
      return { ...state, loading: true };
    case UPDATE_ALLOCATOR_NETWORKS_SUCCESS:
      const allocator = state.profileDetails;
      allocator.senderNetwork = action.payload;
      return {
        ...state,
        allocatorNetworks: allocator,
        loading: false,
      };
    case UPDATE_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, loading: false };

    case DELETE_ALLOCATOR_NETWORKS_INIT:
      return { ...state, loading: true };
    case DELETE_ALLOCATOR_NETWORKS_SUCCESS:
      const allocators = state.profileDetails;
      allocators.recieverNetwork = null;
      allocators.senderNetwork = null;
      return {
        ...state,
        allocatorNetworks: allocators,
        loading: false,
      };
    case DELETE_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
